import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../core/AuthContextProvider";
import ConfirmationPopup from "../common/ConfirmationPopup";

export const Tabs = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [openTab, setOpenTab] = useState("");
  const location = useLocation();
  const { logOut, setUserData } = useAuth();
  const [logoutPopup, setLogoutPopup] = useState(false);

  const logoutHandler = () => {
    setUserData(null);
    logOut();
  };

  useEffect(() => {
    if (
      logoutPopup
        ? (document.body.style.overflow = "hidden")
        : (document.body.style.overflow = "visible")
    );
  }, [logoutPopup]);

  const staticPathNameIdentifier = {
    "/dashboard": "1",
    "/dashboard/products/active": "1.1",
    "/dashboard/products/expired": "1.2",
    "/dashboard/stores": "1.3",
    "/create/corporation": "2.1",
    "/create/organization": "2.2",
    "/create/user": "2.3",
    "/create/product": "2.4",
    "/create/super-user": "2.5",
    "/manage/corporation": "3.1",
    "/edit/corporation": "3.1",
    "/manage/corporation/explore": "3.1",
    "/manage/organization": "3.2",
    "/edit/organization": "3.2",
    "/manage/user": "3.3",
    "/edit/user": "3.3",
    "/manage/product": "3.4",
    "/edit/product": "3.4",
    "/manage/super-user": "3.5",
    "/edit/super-user": "3.5",
    "/search/order": "4",
    "/view/users": "5",
    "/configuration": "6",
  };

  const toggleTab = (tab) => {
    if (tab === openTab) {
      setOpenTab("");
    } else {
      setOpenTab(tab);
    }
  };

  useEffect(() => {
    if (location?.pathname) {
      const path = staticPathNameIdentifier[location?.pathname];
      setActiveTab(path);
      if (path.startsWith("2")) setOpenTab("1");
      else if (path.startsWith("3")) setOpenTab("2");
      else setOpenTab("");
    }
  }, [location]);

  return (
    <div className="mt-5">
      <div className="">
        <div className="bg-white preview">
          <div className="tabs-section">
            <ul id="tabs" className="">
              <nav className="">
                <li
                  className={`font-semibold cursor-pointer rounded-md mx-5  my-4 text-[#1D192B]  hover:bg-[#EEFFD8] hover:text-[#96BF61] ${
                    activeTab.startsWith("1")
                      ? "bg-[#EEFFD8] text-[#96BF61]"
                      : ""
                  }`}
                  onClick={() => {
                    toggleTab(openTab);
                  }}
                >
                  <Link to="/dashboard">
                    <div className="px-[50px] py-3 cursor-pointer relative">
                      <div className="flex items-center w-full ">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M0.666687 0.666748H4.66669V6.00008H0.666687V0.666748ZM0.666687 8.66675H4.66669V11.3334H0.666687V8.66675ZM7.33335 6.00008H11.3334V11.3334H7.33335V6.00008ZM7.33335 0.666748H11.3334V3.33341H7.33335V0.666748Z"
                            stroke={`${
                              activeTab == "1" ? "#96BF61" : "#1D192B"
                            }`}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <span className="pl-6">Dashboard</span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li
                  className={` font-semibold cursor-pointer rounded-t mx-5 px-[50px] py-3 my-4 text-[#1D192B] hover:bg-[#EEFFD8] hover:text-[#96BF61] ${
                    activeTab.startsWith("2") && openTab == "1"
                      ? "bg-[#EEFFD8] text-[#96BF61]"
                      : ""
                  }`}
                  onClick={() => {
                    toggleTab("1");
                  }}
                >
                  <div className=" cursor-pointer">
                    <div className="flex items-center  leading-6 ">
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                      >
                        <path
                          d="M1.4 14.5455C1.015 14.5455 0.6853 14.4032 0.4109 14.1185C0.136967 13.8335 0 13.4909 0 13.0909V2.90909C0 2.50909 0.136967 2.16655 0.4109 1.88145C0.6853 1.59685 1.015 1.45455 1.4 1.45455H4.34C4.49167 1.01818 4.74553 0.666667 5.1016 0.4C5.4572 0.133333 5.85667 0 6.3 0C6.74333 0 7.14303 0.133333 7.4991 0.4C7.8547 0.666667 8.10833 1.01818 8.26 1.45455H11.2C11.585 1.45455 11.9147 1.59685 12.1891 1.88145C12.463 2.16655 12.6 2.50909 12.6 2.90909V7.78182C12.3783 7.67273 12.1508 7.57867 11.9175 7.49964C11.6842 7.42109 11.445 7.36364 11.2 7.32727V2.90909H1.4V13.0909H5.635C5.67 13.3576 5.72553 13.6121 5.8016 13.8545C5.8772 14.097 5.9675 14.3273 6.0725 14.5455H1.4ZM1.4 12.3636V13.0909V2.90909V7.32727V7.27273V12.3636ZM2.8 11.6364H5.6525C5.6875 11.3818 5.7428 11.1333 5.8184 10.8909C5.89447 10.6485 5.97917 10.4121 6.0725 10.1818H2.8V11.6364ZM2.8 8.72727H7.07C7.44333 8.36364 7.8603 8.06061 8.3209 7.81818C8.78197 7.57576 9.275 7.41212 9.8 7.32727V7.27273H2.8V8.72727ZM2.8 5.81818H9.8V4.36364H2.8V5.81818ZM6.3 2.36364C6.45167 2.36364 6.5772 2.312 6.6766 2.20873C6.77553 2.10594 6.825 1.97576 6.825 1.81818C6.825 1.66061 6.77553 1.53018 6.6766 1.42691C6.5772 1.32412 6.45167 1.27273 6.3 1.27273C6.14833 1.27273 6.02303 1.32412 5.9241 1.42691C5.8247 1.53018 5.775 1.66061 5.775 1.81818C5.775 1.97576 5.8247 2.10594 5.9241 2.20873C6.02303 2.312 6.14833 2.36364 6.3 2.36364ZM10.5 16C9.53167 16 8.70637 15.6456 8.0241 14.9367C7.34137 14.2274 7 13.3697 7 12.3636C7 11.3576 7.34137 10.4999 8.0241 9.79055C8.70637 9.0817 9.53167 8.72727 10.5 8.72727C11.4683 8.72727 12.2939 9.0817 12.9766 9.79055C13.6589 10.4999 14 11.3576 14 12.3636C14 13.3697 13.6589 14.2274 12.9766 14.9367C12.2939 15.6456 11.4683 16 10.5 16ZM10.15 14.5455H10.85V12.7273H12.6V12H10.85V10.1818H10.15V12H8.4V12.7273H10.15V14.5455Z"
                          fill={`${
                            activeTab.startsWith("2") && openTab == "1"
                              ? "#96BF61"
                              : "#1D192B"
                          }`}
                        />
                      </svg>
                      <span className="pl-6">Create</span>
                      <div
                        className={"pl-6 " + (openTab == "1" ? "hidden" : "")}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                            fill={`${
                              activeTab.startsWith("2") && openTab == "1"
                                ? "#96BF61"
                                : "#1D192B"
                            }`}
                          />
                        </svg>
                      </div>
                      <div
                        className={"pl-6 " + (openTab == "1" ? "" : "hidden")}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            d="m12 6.586-8.707 8.707 1.414 1.414L12 9.414l7.293 7.293 1.414-1.414L12 6.586z"
                            fill={`${
                              activeTab.startsWith("2") && openTab == "1"
                                ? "#96BF61"
                                : "#1D192B"
                            }`}
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </li>
                {openTab == "1" && (
                  <li>
                    <ul className="overflow-hidden">
                      <li className="relative grid bg-white">
                        <Link className="group" to="/create/corporation">
                          <div className="space-y-1">
                            <p
                              className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                activeTab === "2.1" ? "text-[#96BF61]" : ""
                              }`}
                            >
                              Corporation
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="relative grid bg-white">
                        <Link className="group" to="/create/organization">
                          <div className="space-y-1">
                            <p
                              className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                activeTab === "2.2" ? "text-[#96BF61]" : ""
                              } `}
                            >
                              Organization
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="relative grid bg-white">
                        <Link className="group" to="/create/user">
                          <div className="space-y-1">
                            <p
                              className={`text-base mx-8 pl-[70px] pl-[40px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                activeTab === "2.3" ? "text-[#96BF61]" : ""
                              }`}
                            >
                              Customer Admin
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="relative grid bg-white">
                        <Link className="group" to="/create/super-user">
                          <div className="space-y-1">
                            <p
                              className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                activeTab === "2.5" ? "text-[#96BF61]" : ""
                              }`}
                            >
                              Super User
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="relative grid bg-white">
                        <Link className="group" to="/create/product">
                          <div className="space-y-1">
                            <p
                              className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                activeTab === "2.4" ? "text-[#96BF61]" : ""
                              }`}
                            >
                              Product
                            </p>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li
                  className={` font-semibold cursor-pointer rounded-md mx-5 px-[50px] py-3 my-4 text-[#1D192B]   hover:bg-[#EEFFD8] hover:text-[#96BF61]  ${
                    activeTab.startsWith("3") && openTab == "2"
                      ? "bg-[#EEFFD8] text-[#96BF61]"
                      : ""
                  }`}
                  onClick={() => {
                    toggleTab("2");
                  }}
                >
                  <div className=" cursor-pointer ">
                    <div className="flex items-center leading-6 ">
                      <svg
                        width="17"
                        height="14"
                        viewBox="0 0 17 14"
                        fill="none"
                      >
                        <path
                          d="M2.03477 12.4444C1.61271 12.4444 1.25153 12.2923 0.951223 11.9879C0.650408 11.683 0.5 11.3167 0.5 10.8889V1.55556C0.5 1.12778 0.650408 0.761704 0.951223 0.457333C1.25153 0.152444 1.61271 0 2.03477 0H6.63909L8.17386 1.55556H14.3129C14.735 1.55556 15.0965 1.708 15.3973 2.01289C15.6976 2.31726 15.8477 2.68333 15.8477 3.11111V5.63889C15.6175 5.47037 15.3745 5.32778 15.1187 5.21111C14.8629 5.09444 14.5943 4.99074 14.3129 4.9V3.11111H2.03477V10.8889H7.46403C7.5024 11.1611 7.55995 11.4269 7.63669 11.6861C7.71343 11.9454 7.80935 12.1981 7.92446 12.4444H2.03477ZM12.0108 14L11.7806 12.8333C11.6271 12.7685 11.4833 12.7006 11.3493 12.6296C11.2148 12.558 11.0771 12.4704 10.9365 12.3667L9.82374 12.7167L9.05635 11.3944L9.93885 10.6167C9.91327 10.4611 9.90048 10.2926 9.90048 10.1111C9.90048 9.92963 9.91327 9.76111 9.93885 9.60556L9.05635 8.82778L9.82374 7.50556L10.9365 7.85556C11.0771 7.75185 11.2148 7.66422 11.3493 7.59267C11.4833 7.52163 11.6271 7.4537 11.7806 7.38889L12.0108 6.22222H13.5456L13.7758 7.38889C13.9293 7.4537 14.0733 7.52163 14.2078 7.59267C14.3419 7.66422 14.4792 7.75185 14.6199 7.85556L15.7326 7.50556L16.5 8.82778L15.6175 9.60556C15.6431 9.76111 15.6559 9.92963 15.6559 10.1111C15.6559 10.2926 15.6431 10.4611 15.6175 10.6167L16.5 11.3944L15.7326 12.7167L14.6199 12.3667C14.4792 12.4704 14.3419 12.558 14.2078 12.6296C14.0733 12.7006 13.9293 12.7685 13.7758 12.8333L13.5456 14H12.0108ZM12.7782 11.6667C13.2002 11.6667 13.5617 11.5145 13.8625 11.2101C14.1628 10.9052 14.3129 10.5389 14.3129 10.1111C14.3129 9.68333 14.1628 9.31726 13.8625 9.01289C13.5617 8.708 13.2002 8.55556 12.7782 8.55556C12.3561 8.55556 11.9947 8.708 11.6939 9.01289C11.3936 9.31726 11.2434 9.68333 11.2434 10.1111C11.2434 10.5389 11.3936 10.9052 11.6939 11.2101C11.9947 11.5145 12.3561 11.6667 12.7782 11.6667Z"
                          fill={`${
                            activeTab.startsWith("3") && openTab == "2"
                              ? "#96BF61"
                              : "#1D192B"
                          }`}
                        />
                      </svg>
                      <span className="pl-6">Manage</span>
                      <div
                        className={"pl-6 " + (openTab == "2" ? "hidden" : "")}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                            fill={`${
                              activeTab.startsWith("3") && openTab == "2"
                                ? "#96BF61"
                                : "#1D192B"
                            }`}
                          />
                        </svg>
                      </div>
                      <div
                        className={"pl-6 " + (openTab == "2" ? "" : "hidden")}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                          <path
                            d="m12 6.586-8.707 8.707 1.414 1.414L12 9.414l7.293 7.293 1.414-1.414L12 6.586z"
                            fill={`${
                              activeTab.startsWith("3") && openTab == "2"
                                ? "#96BF61"
                                : "#1D192B"
                            }`}
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </li>

                {openTab == "2" && (
                  <li>
                    <div className=" w-full flex cursor-pointer justify-center max-w-sm px-2 sm:px-0">
                      <div id="submenu-Create" className="rounded-xl">
                        <ul className="overflow-hidden">
                          <li className="relative grid bg-white">
                            <Link className="group" to="/manage/corporation">
                              <div className="space-y-1">
                                <p
                                  className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                    activeTab === "3.1" ? "text-[#96BF61]" : ""
                                  }`}
                                >
                                  Corporation
                                </p>
                              </div>
                            </Link>
                          </li>
                          <li className="relative grid bg-white">
                            <Link className="group" to="/manage/organization">
                              <div className="space-y-1">
                                <p
                                  className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                    activeTab === "3.2" ? "text-[#96BF61]" : ""
                                  } `}
                                >
                                  Organization
                                </p>
                              </div>
                            </Link>
                          </li>
                          <li className="relative grid bg-white">
                            <Link className="group" to="/manage/user">
                              <div className="space-y-1">
                                <p
                                  className={`text-base mx-8 pl-[70px] pl-[40px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                    activeTab === "3.3" ? "text-[#96BF61]" : ""
                                  }`}
                                >
                                  Customer Admin
                                </p>
                              </div>
                            </Link>
                          </li>
                          <li className="relative grid bg-white">
                            <Link className="group" to="/manage/super-user">
                              <div className="space-y-1">
                                <p
                                  className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                    activeTab === "3.5" ? "text-[#96BF61]" : ""
                                  }`}
                                >
                                  Super User
                                </p>
                              </div>
                            </Link>
                          </li>
                          <li className="relative grid bg-white">
                            <Link className="group" to="/manage/product">
                              <div className="space-y-1">
                                <p
                                  className={`text-base mx-8 px-[70px] py-3 font-medium leading-6 text-[#1D192B] hover:text-[#96BF61] hover:bg-[#EEFFD8] ${
                                    activeTab === "3.4" ? "text-[#96BF61]" : ""
                                  }`}
                                >
                                  Product
                                </p>
                              </div>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                )}

                <li
                  className={` font-semibold cursor-pointer rounded-md mx-5  my-4 text-[#1D192B]   hover:bg-[#EEFFD8] hover:text-[#96BF61]  ${
                    activeTab === "4" ? "bg-[#EEFFD8] text-[#96BF61]" : ""
                  }`}
                  onClick={() => {
                    toggleTab(openTab);
                  }}
                >
                  <Link to="/search/order">
                    <div className="px-[50px] py-3 cursor-pointer relative">
                      <div className="flex items-center leading-6 ">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M10.6 11.5333L6.86667 7.8C6.53333 8.06667 6.15 8.27778 5.71667 8.43333C5.28333 8.58889 4.82222 8.66667 4.33333 8.66667C3.12222 8.66667 2.09733 8.24733 1.25867 7.40867C0.419556 6.56956 0 5.54444 0 4.33333C0 3.12222 0.419556 2.09711 1.25867 1.258C2.09733 0.419333 3.12222 0 4.33333 0C5.54444 0 6.56956 0.419333 7.40867 1.258C8.24733 2.09711 8.66667 3.12222 8.66667 4.33333C8.66667 4.82222 8.58889 5.28333 8.43333 5.71667C8.27778 6.15 8.06667 6.53333 7.8 6.86667L11.55 10.6167C11.6722 10.7389 11.7333 10.8889 11.7333 11.0667C11.7333 11.2444 11.6667 11.4 11.5333 11.5333C11.4111 11.6556 11.2556 11.7167 11.0667 11.7167C10.8778 11.7167 10.7222 11.6556 10.6 11.5333ZM4.33333 7.33333C5.16667 7.33333 5.87511 7.04178 6.45867 6.45867C7.04178 5.87511 7.33333 5.16667 7.33333 4.33333C7.33333 3.5 7.04178 2.79156 6.45867 2.208C5.87511 1.62489 5.16667 1.33333 4.33333 1.33333C3.5 1.33333 2.79156 1.62489 2.208 2.208C1.62489 2.79156 1.33333 3.5 1.33333 4.33333C1.33333 5.16667 1.62489 5.87511 2.208 6.45867C2.79156 7.04178 3.5 7.33333 4.33333 7.33333Z"
                            fill={`${activeTab == "4" ? "#96BF61" : "#1D192B"}`}
                          />
                        </svg>

                        <span className="pl-6">Search Order</span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li
                  className={` font-semibold cursor-pointer rounded-md mx-5  my-4 text-[#1D192B]   hover:bg-[#EEFFD8] hover:text-[#96BF61]  ${
                    activeTab === "5" ? "bg-[#EEFFD8] text-[#96BF61]" : ""
                  }`}
                  onClick={() => {
                    toggleTab(openTab);
                  }}
                >
                  <Link to="/view/users">
                    <div className="px-[50px] py-3 cursor-pointer relative">
                      <div className="flex items-center leading-6 ">
                        <svg
                          fill={`${activeTab == "5" ? "#96BF61" : "#1D192B"}`}
                          width="16"
                          height="16"
                          viewBox="250 250 600 600"
                        >
                          <circle cx="435.2" cy="409.5" r="102.4" />
                          <path d="M588.8 409.5c0 17.6-3.1 34.5-8.6 50.3 2.9.2 5.7.9 8.6.9 56.6 0 102.4-45.8 102.4-102.4 0-56.6-45.8-102.4-102.4-102.4-26.1 0-49.7 10.1-67.8 26.2 40.9 27.7 67.8 74.4 67.8 127.4zM435.2 563.1c-128 0-179.2 25.6-179.2 102.4v102.6h358.4V665.5c0-77.3-51.2-102.4-179.2-102.4z" />
                          <path d="M588.8 511.9c-14.5 0-27.9.4-40.5 1.1-2.3 2.5-4.6 4.9-7 7.2 63.7 13.5 124.2 49.5 124.2 145.3v51.4H768V614.3c0-77.3-51.2-102.4-179.2-102.4z" />
                        </svg>
                        <span className="pl-6">View Users</span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li
                  className={` font-semibold cursor-pointer rounded-md mx-5  my-4 text-[#1D192B]   hover:bg-[#EEFFD8] hover:text-[#96BF61]  ${
                    activeTab === "6" ? "bg-[#EEFFD8] text-[#96BF61]" : ""
                  }`}
                  onClick={() => {
                    toggleTab(openTab);
                  }}
                >
                  <Link to="/configuration">
                    <div className="px-[50px] py-3 cursor-pointer relative">
                      <div className="flex items-center leading-6 ">
                        <svg width="16" height="16" viewBox="0 0 32 32" fill="none">
                          <path d="M28.8,20.2c-1.1,0.2-2,0-2.4-0.7c-0.4-0.7-0.1-1.7,0.6-2.5c-0.9-0.9-1.9-1.5-3.1-1.8c-0.3,1-1,1.8-1.8,1.8s-1.5-0.7-1.8-1.8c-1.2,0.3-2.3,0.9-3.1,1.8c0.7,0.8,1,1.8,0.6,2.5c-0.4,0.7-1.4,0.9-2.4,0.7C15.1,20.8,15,21.4,15,22s0.1,1.2,0.2,1.8c1.1-0.2,2,0,2.4,0.7c0.4,0.7,0.1,1.7-0.6,2.5c0.9,0.9,1.9,1.5,3.1,1.8c0.3-1,1-1.8,1.8-1.8s1.5,0.7,1.8,1.8c1.2-0.3,2.3-0.9,3.1-1.8c-0.7-0.8-1-1.8-0.6-2.5c0.4-0.7,1.4-0.9,2.4-0.7c0.2-0.6,0.2-1.2,0.2-1.8S28.9,20.8,28.8,20.2z" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                          <circle cx="22" cy="22" r="2" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                          <line x1="5" y1="12" x2="21" y2="12" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2"/>
                          <path d="M10.5,8.1L9.3,3.9l0,0c2.3-1.2,5.1-1.2,7.4,0l0,0l-1.2,4.2" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                          <path d="M16.5,4.9c2,1.2,3.3,3.4,3.3,5.9V12" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                          <path d="M6.2,12v-1.2c0-2.5,1.3-4.7,3.3-5.9" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                          <path d="M8,12v2c0,2.1,0.9,4,2.5,5v0c0,2.1-1.3,3.9-3.2,4.4C5.1,24,3.5,26,3,28.4C3,28.7,3.2,29,3.5,29H13" stroke={`${activeTab == "6" ? "#96BF61" : "#1D192B"}`} strokeWidth="2" fill="none"/>
                        </svg>
                        <span className="pl-6">Configuration</span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li
                  className={`font-semibold cursor-pointer rounded-md mx-5  my-4  text-[#1D192B]  hover:bg-[#EEFFD8] hover:text-[#96BF61] ${
                    activeTab === "7" ? "bg-[#EEFFD8] text-[#96BF61]" : ""
                  }`}
                >
                  <div
                    onClick={() => {
                      setLogoutPopup(true);
                    }}
                  >
                    <div className="px-[50px] py-3 cursor-pointer relative">
                      <div className="flex items-center leading-6 ">
                        <svg
                          fill="#000000"
                          width="15px"
                          height="15px"
                          viewBox="0 0 32 32"
                          version="1.1"
                        >
                          <path d="M3.651 16.989h17.326c0.553 0 1-0.448 1-1s-0.447-1-1-1h-17.264l3.617-3.617c0.391-0.39 0.391-1.024 0-1.414s-1.024-0.39-1.414 0l-5.907 6.062 5.907 6.063c0.196 0.195 0.451 0.293 0.707 0.293s0.511-0.098 0.707-0.293c0.391-0.39 0.391-1.023 0-1.414zM29.989 0h-17c-1.105 0-2 0.895-2 2v9h2.013v-7.78c0-0.668 0.542-1.21 1.21-1.21h14.523c0.669 0 1.21 0.542 1.21 1.21l0.032 25.572c0 0.668-0.541 1.21-1.21 1.21h-14.553c-0.668 0-1.21-0.542-1.21-1.21v-7.824l-2.013 0.003v9.030c0 1.105 0.895 2 2 2h16.999c1.105 0 2.001-0.895 2.001-2v-28c-0-1.105-0.896-2-2-2z" />
                        </svg>

                        <span className="pl-6">Log Out</span>
                      </div>
                    </div>
                  </div>
                </li>
              </nav>
            </ul>
          </div>
        </div>
      </div>
      {logoutPopup && (
        <ConfirmationPopup
          popup={logoutPopup}
          setPopup={setLogoutPopup}
          logout={logoutHandler}
        />
      )}
    </div>
  );
};
// Tabs.propTypes = {
//   children: PropTypes.node.isRequired,
// };

export default Tabs;
